<div class="card-inline">
    <h1 class="card-inline" mat-dialog-title>Tareas finalizadas</h1>
    <button class="card-inline" matTooltip="Actualizar" (click)="loadScheduleTaskSearchItems()" mat-mini-fab>
      <mat-icon>refresh</mat-icon>
  </button>
</div>
<mat-divider></mat-divider>
<div class="table-scroll">
    <mat-spinner *ngIf="loading"></mat-spinner>
    <table *ngIf="!loading" class="table-content">
        <tr>
            <th>Nombre</th>
            <th class="cell-date">Horario</th>
            <th></th>
        </tr>

        <tr *ngFor="let scheduleTaskSearchItem of scheduleTaskSearchItems">
            <td>{{ scheduleTaskSearchItem.Name }}</td>
            <td class="cell-date">{{ scheduleTaskSearchItem.Date | date : 'dd/MM/yyyy HH:mm' }}</td>
            <td *ngIf="!scheduleTaskSearchItem.LoadingAction">
                <mat-icon *ngIf="!scheduleTaskSearchItem.Finished && !scheduleTaskSearchItem.HasError">alarm</mat-icon>
                <mat-icon *ngIf="scheduleTaskSearchItem.Finished && !scheduleTaskSearchItem.HasError && !hasDownloadResponseAction(scheduleTaskSearchItem)">done</mat-icon>
                <mat-icon (click)="doAction(scheduleTaskSearchItem)" *ngIf="scheduleTaskSearchItem.Finished && !scheduleTaskSearchItem.HasError && hasDownloadResponseAction(scheduleTaskSearchItem)">cloud_download</mat-icon>
                <mat-icon [matTooltip]="scheduleTaskSearchItem.Error" *ngIf="scheduleTaskSearchItem.HasError">error</mat-icon>
            </td>
            <td *ngIf="scheduleTaskSearchItem.LoadingAction">
                <mat-spinner [diameter]="25"></mat-spinner>
            </td>
        </tr>
    </table>
</div>